import { ActionTypeReducer, GenStateType, NestedKeys } from "helpers/types";

type PassForm = {
    password: string;
    passwordConfirm: string;
}

enum Step {
    EMAIL = 0,
    CODE = 1,
    PASSWORD = 2,
}

type StateType = {
    loading: boolean;
    step: keyof typeof Step;
    email: string;
    code: string;
    passForm: PassForm;
    passFormFieldsError: Partial<Record<NestedKeys<StateType["passForm"]>, string>>;
    errorTitle: string;
    errorMsg: string;
    error: boolean;
}

type ActionType = GenStateType<StateType>;

const initialState: StateType = {
    loading: false,
    step: "EMAIL",
    email: "",
    code: "",
    passForm: {
        password: "",
        passwordConfirm: "",
    },
    passFormFieldsError: {
        password: "",
        passwordConfirm: "",
    },
    errorTitle: '',
    errorMsg: '',
    error: false,
};

const reducer = (state: StateType, action: ActionTypeReducer<ActionType>) => {
    switch (action.type) {
        case "setLoading":
            return { ...state, loading: action.payload };
        case "setStep":
            return { ...state, step: action.payload };
        case "setEmail":
            return { ...state, email: action.payload };
        case "setCode":
            return { ...state, code: action.payload };
        case "setPassForm":
            return { ...state, passForm: action.payload };
        case "setPassFormFieldsError":
            return { ...state, passFormFieldsError: action.payload };
        case "setErrorTitle":
            return { ...state, errorTitle: action.payload };
        case "setErrorMsg":
            return { ...state, errorMsg: action.payload };
        case "setError":
            return { ...state, error: action.payload };
        default:
            return state;
    }
}

export { initialState, reducer };
